
import React from 'react';
import { Route } from 'react-router-dom';
import { 
  mainRoutes, 
  groupRoutes, 
  valorisationRoutes, 
  geographicRoutes, 
  legalRoutes 
} from './routeDefinitions';
import { serviceClientRoutes } from './serviceRoutes';
import { metalTypeRoutes, metalGeographicRoutes, metalDepartmentRoutes } from './metalRoutes';
import { seoLocationRoutes, seoKeywordRoutes } from './seoRoutes';
import { individualSiteRoutes } from './siteRoutes';

export const StandardRoutes = () => {
  console.log("Loading StandardRoutes with mainRoutes:", mainRoutes.map(r => r.path));
  
  return [
  // Main routes
  ...mainRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Service client routes
  ...serviceClientRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Metal type routes
  ...metalTypeRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Metal geographic routes
  ...metalGeographicRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Metal department routes (by number)
  ...metalDepartmentRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // SEO location routes
  ...seoLocationRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // SEO keyword routes
  ...seoKeywordRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Group routes
  ...groupRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Individual site routes
  ...individualSiteRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Valorisation routes
  ...valorisationRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Geographic routes
  ...geographicRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  )),

  // Legal routes
  ...legalRoutes.map(({ path, element: Component }) => (
    <Route key={path} path={path} element={<Component />} />
  ))
  ];
};
